import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const fetchCategories = createAsyncThunk("categories/fetchAll", async () => {
    return await ApiService.get("/categories",false);
  });
  
  export const fetchCategoryById = createAsyncThunk("categories/fetchById", async (id) => {
    return await ApiService.getById("/category", id);
  });
  
  